import {
	getComplaintPage,
	ntcPrintInfo,
	ntcPrintInfoDetail,
	replyComplaint
} from '@/api/notice'
// import { getToken } from '@/utils/auth'
const state = {}
const mutations = {}

const actions = {
	ntcPrintInfoDetail ({}, data) {
		return new Promise((resolve, reject) => {
			ntcPrintInfoDetail(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	ntcPrintInfo ({}, data) {
		return new Promise((resolve, reject) => {
			ntcPrintInfo(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getComplaintPage ({}, data) {
		return new Promise((resolve, reject) => {
			getComplaintPage(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	replyComplaint ({}, data) {
		return new Promise((resolve, reject) => {
			replyComplaint(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
